import Head from 'next/head';
import React from 'react';

import { renderJsonLdScript, getFaqStructuredData } from 'libs/universal/structuredData';
import { REGISTRY_LP_SCHEMA } from 'constants/schemas/registryLPSchema';
import LeCreuset from '../../../../../public/static-preauth/images/WeddingRegistryLP/V3/Metadata/LeCreuset.webp';
import FAQ_LD from './faqLd';

const title = 'Wedding Registry, Seamless & Easy';
const description =
  'Create your wedding registry. Integrate registries from other sites, link your registry to your wedding website, and make gifting easy for your guests! 24/7 customer support.';

export default function Header(): JSX.Element {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={LeCreuset} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="zola.com" />
      <meta name="twitter:site" content="@zola" />
      <meta name="twitter:card" content="summary_large_image" />
      <link rel="canonical" href="https://www.zola.com/wedding-registry" />
      {renderJsonLdScript(REGISTRY_LP_SCHEMA)}
      {renderJsonLdScript(getFaqStructuredData(FAQ_LD))}
    </Head>
  );
}
